export const env = {
  AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN as string,
  AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID as string,
  AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE as string,
  BACK_DASHBOARD_API_URL: import.meta.env.VITE_BACK_DASHBOARD_API_URL as string,
  GRAPH_PROXY_URL: import.meta.env.VITE_GRAPH_PROXY_URL as string,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string,
  SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT as string,
  SENTRY_RELEASE: import.meta.env.VITE_SENTRY_RELEASE as string,
  EPISOD_URL: import.meta.env.VITE_EPISOD_URL as string,
  EPISOD_X_CLIENT_ID: import.meta.env.VITE_EPISOD_X_CLIENT_ID as string,
  EPISOD_COOKIE_DOMAIN: import.meta.env.VITE_EPISOD_COOKIE_DOMAIN as string,
  METRICS_DASHBOARD_URL: import.meta.env.VITE_METRICS_DASHBOARD_URL as string,
  MOCK_AUTH: import.meta.env.VITE_MOCK_AUTH === 'true',
};
